import map from './assets/group-map-terrain.png'
import suwang from './assets/suwang-night.png'
import wusong from './assets/wusong-night.png'
import tayun from './assets/tayun-night.png'
import suwangBalanced from './assets/suwang-night-balanced.png'
import wusongBalanced from './assets/wusong-night-balanced.png'
import tayunBalanced from './assets/tayun-night-balanced.png'
import nandu from '../nandu-energy-screen/assets/nandu-night-scene-v2.png'
import { screenConfig } from '../nandu-energy-screen/data'

export const mapImage = map
export const scenes = { nandu, suwang, wusong, tayun }
// Keep the existing group snapshot photos; use wider compositions in the child screens.
const projectScenes = { nandu, suwang: suwangBalanced, wusong: wusongBalanced, tayun: tayunBalanced }
const sceneAnchors = {
  tayun: { tower: [50, 46], entrance: [50, 69], label: [33, 36], entryLabel: [59, 67] },
  wusong: { tower: [50, 48], entrance: [52, 66], label: [34, 29], entryLabel: [61, 66] },
  suwang: { tower: [41, 44], entrance: [50, 66], label: [32, 31], entryLabel: [61, 68] }
}
export function projectConfig (project) {
  const anchor = sceneAnchors[project.scene]
  const landmarks = project.scene === 'nandu' ? screenConfig.landmarks : [
    { id: 'tower', label: project.shortName, x: anchor.tower[0], y: anchor.tower[1], labelX: anchor.label[0], labelY: anchor.label[1], leader: [anchor.label, anchor.tower] },
    { id: 'entrance', label: '项目入口', x: anchor.entrance[0], y: anchor.entrance[1], labelX: anchor.entryLabel[0], labelY: anchor.entryLabel[1], leader: [anchor.entryLabel, anchor.entrance] }
  ]
  return { ...screenConfig, projectName: project.name, title: `${project.shortName}智慧能源管理大屏`, sceneSource: projectScenes[project.scene], hasPv: project.hasPv, landmarks }
}
